import React, { Component } from "react";
import axios from 'axios'
import Loading from '../shared/Loading';
import { subscriber } from './apis/accountManagementApis';
import { EIR_WEBMAIL_CONST } from './constants/EirWebmailConstants';

class EirWebmailLoginRedirect extends Component {
    // add a constructor to the class to initialize the states
    constructor(props) {
        super(props);
        this.state = {
            // environment:  this.props.environment,
            userName: 'basic',
            password: 'basic'
        };
    }
    async componentDidMount() {
        // let getURLParams = window.location.search.substring(1);
        let getURLParams = window.location.href.split("?")[1];
        console.log("getURLParams >> ", getURLParams);
        let navigateToPage = "";
        let getToken = "";
        let emailAddress = "";
        let password = "";
        let basicVersion = false;
        let encryptedMessage = "";//e1
        let encryptedKey = "";//e2
        let subscriberStatus = "";
        let addToken = "";
        let otherErrorCase = "";
        getURLParams = getURLParams.split("&");
        for (let i = 0; i < getURLParams.length; i++) {
            if (getURLParams[i].indexOf("page") == 0) {
                navigateToPage = getURLParams[i].split("=")[1]
            } else if (getURLParams[i].indexOf("Auth") == 0) {
                getToken = getURLParams[i].split("=")[1]
            } else if (getURLParams[i].indexOf("email") == 0) {
                emailAddress = getURLParams[i].split("=")[1]
            } else if (getURLParams[i].indexOf("basic") == 0) {
                basicVersion = getURLParams[i].split("=")[1]
            } else if (getURLParams[i].indexOf("pwd") == 0) {
                password = getURLParams[i].split("=")[1]
            } else if (getURLParams[i].indexOf("e1=") == 0) {
                encryptedMessage = getURLParams[i].substr(3, getURLParams[i].length)
            } else if (getURLParams[i].indexOf("e2=") == 0) {
                encryptedKey = getURLParams[i].substr(3, getURLParams[i].length)
            } else if (getURLParams[i].indexOf("AddToken") == 0) {
                addToken = getURLParams[i].split("=")[1]
            }
        }

        sessionStorage.setItem("webmailLoggedinUser", emailAddress);
        sessionStorage.setItem("WEBMAIL_AUTH_TOKEN", getToken);
        sessionStorage.setItem("WEBMAIL_ADD_TOKEN", addToken);
        let subscriberUrl = ''
        if (sessionStorage.getItem('WEBMAIL_AUTH_TOKEN') === '0_') {
            subscriberUrl = `${EIR_WEBMAIL_CONST.url.PRIVATE_SUBSCRIBER}/public/webmail/subscriber/${emailAddress}`
        } else {
            subscriberUrl = EIR_WEBMAIL_CONST.url.GET_SUBSCRIBER_URL + emailAddress
        }
        await axios({
            method: "get",
            url: subscriberUrl,
            headers: {
                Authorization: 'Bearer ' + addToken,
            }
        })
            .then(res => {
                subscriberStatus = res.data.status.toLowerCase();
            }).catch((error) => {
                //any status other than 200 to go to offers/acc-mgmt 
                if (error.response != undefined && error.response.status != 200) {
                    // if (navigateToPage.toLowerCase() === "offers") window.location.href = "/email/offers";
                    // if (navigateToPage.toLowerCase() === "account") window.location.href = "/email/account-management";
                    if (getToken.toLowerCase() !== "disabled") {
                        (error.response.status == 404) ? navigateToPage = "offers" : otherErrorCase = "gotozimbra";
                    } else {
                        console.log()
                        navigateToPage = "offers";
                        //navigateToPage = "disabledandsubscribernotfound";
                    }

                }
            });

        /*if(navigateToPage.toLowerCase() === "disabledandsubscribernotfound" ){
            window.location.href = "/email/login?error=25"
        }*/
        if (otherErrorCase === "gotozimbra") {
            //when classic mail user logs in, the url will have the token=classic as param - the form to be submitted
            if (getToken.toLowerCase() == "classic") {
                this.setState({ userName: emailAddress });
                this.setState({ password: password });
                document.forms[0].method = "post";
                document.forms[0].action = EIR_WEBMAIL_CONST.url.CLASSIC_WEB_MAIL_URL;
                document.forms[0].submit();
            } else if (getToken.toLowerCase() !== "classic") {
                (!basicVersion) ?
                    window.location.href = EIR_WEBMAIL_CONST.url.ZIMBRA_MAIL_URL + "/service/preauth?isredirect=1&redirectURL=/zimbra/h/&authtoken=" + getToken
                    :
                    window.location.href = EIR_WEBMAIL_CONST.url.ZIMBRA_MAIL_URL + "/service/preauth?isredirect=1&authtoken=" + getToken
            }
        }

        if (navigateToPage.toLowerCase() === "offers" && subscriberStatus !== "ceased") {
            //when classic mail user logs in, the url will have the token=classic as param - the form to be submitted
            if (getToken.toLowerCase() == "classic" && (subscriberStatus === "active" || subscriberStatus === "pending_cease" || subscriberStatus === "arrears")) {  //if pending_cease user should be able to access the mail
                this.setState({ userName: emailAddress });
                this.setState({ password: password });
                document.forms[0].method = "post";
                document.forms[0].action = EIR_WEBMAIL_CONST.url.CLASSIC_WEB_MAIL_URL;
                document.forms[0].submit();
            } else if (getToken.toLowerCase() !== "classic" && (subscriberStatus === "active" || subscriberStatus === "pending_cease" || subscriberStatus === "arrears")) {
                (!basicVersion) ?
                    window.location.href = EIR_WEBMAIL_CONST.url.ZIMBRA_MAIL_URL + "/service/preauth?isredirect=1&redirectURL=/zimbra/h/&authtoken=" + getToken
                    :
                    window.location.href = EIR_WEBMAIL_CONST.url.ZIMBRA_MAIL_URL + "/service/preauth?isredirect=1&authtoken=" + getToken
            }
            else if (subscriberStatus == 'pending_active') {
                window.location.href = '/email/payment'
            }
            else if ((subscriberStatus !== "active" || subscriberStatus !== "ceased")) {
                window.location.href = "/email/offers"
            }
        } else if (navigateToPage.toLowerCase() === "account" && subscriberStatus !== "ceased" && getToken.toLowerCase() !== "disabled") {
            window.location.href = "/email/account-management"
        } else if ((navigateToPage.toLowerCase() === "account" && getToken.toLowerCase() === "disabled" && subscriberStatus !== "ceased")) {
            window.location.href = "/email/login?error=24"
        } else if ((navigateToPage.toLowerCase() === "account1" && getToken.toLowerCase() === "disabled" && subscriberStatus !== "ceased")) {
            window.location.href = "/email/account-management"
        } else if (subscriberStatus === "ceased") {
            window.location.href = "/email/login?error=23"
        } else if (navigateToPage.toLowerCase() === "disabledandsubscribernotfound") {
            window.location.href = "/email/login?error=25"
        } else {
            window.location.href = "/email/login"
        }
    }


    renderContent = (content) => {
        return { __html: content };
    }
    render() {
        return (
            <div className=" mb-3 mb-md-5 mt-4 eir-theme-default container webmail-container">
                {/* <h2 className="eir-title display-4 eir-display-xl-3">{this.props.title}</h2> */}
                <Loading className="m-5" />
                <form name="myform">
                    <input type="hidden" name="username" value={this.state.userName} />
                    <input type="hidden" name="password" value={this.state.password} />
                </form>
            </div>
        )
    }
}
export default EirWebmailLoginRedirect;